import { RouteRecordRaw } from "vue-router";
import { ROLES_AND_PERMISSION_ON_ROUTES } from "@/core/configs/rolesAndPermissionsMappingOnRoutes";

const routes: Array<RouteRecordRaw> = [
  {
    path: "",
    name: "404",
    meta: {
      roles: ROLES_AND_PERMISSION_ON_ROUTES.Error404.ROLES,
      permissions: ROLES_AND_PERMISSION_ON_ROUTES.Error404.PERMISSIONS,
    },
    component: () => import("../views/Error404.vue"),
  },
];

export default routes;
